export enum FormStatus {
	WaitingManagerApproval = 1,
	Approved = 2,
	Denied = 3,
	Cancelled = 4,
	Completed = 5,
	Submitted = 6,
	Saved = 7
}

export enum FormType {
    Procurement = 1,
    TrafficTeam = 2
}

export enum Roles {
	Default = 1,
	BudgetManager = 2,
	Purchaser = 4,
	ApMangaer = 8,
	//this is for checking to see if they have permissions
	Edit = 99
}

export enum AirFreightRoles {
    Default = 1,
    BudgetManager = 2,
    Traffic = 4,
    ApManager = 8,
    Edit = 99
}

export enum QuoteStatuses {
    TeamObtainingQuotes = 1,
    SelectQuote = 2,
    WaitingManagerApproval = 3,
    WaitingTrackingInformation = 4,
    Denied = 5,
    Cancelled = 6,
    Completed = 7,
    Submitted = 8,
    Saved = 9,
    Approved = 10
}